export default __webpack_public_path__ + "static/media/cooking.f8f0422a.svg";